module.exports = __webpack_public_path__ + "static/media/general-podiatry.ad0118c9.jpg";